// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"395c4105","239":"14430c9e","455":"8f1cbabc","488":"4c592ce9"}[chunkId] + ".chunk.js";
};